import React from 'react'

import 'react-multi-carousel/lib/styles.css'
import { useTranslation } from 'react-i18next'
import { Link, useSearchParams } from 'react-router-dom'

import { TSList } from './TSList'
import AppLayout from '../common/AppLayout'
import AppTitle from '../common/AppTitle'

function TimesheetPage() {
    const {t} = useTranslation()
    const [searchParams,] = useSearchParams()

    return (
        <AppLayout>
            <AppTitle append={<Link to={'/app/timesheet/add'}>
                <button className="amani-primary">{t('add_record')}</button>
            </Link>}>{t('timesheet')}</AppTitle>
            {searchParams.get('new') ? <div className="alert alert-success">{t('record_added_success')}</div> : null}

            <TSList/>
        </AppLayout>
    )
}

export default TimesheetPage
